export enum DeliveryType {
  self = 'self',
  delivery = 'delivery',
}